import { useEffect } from 'react';
import { setUserContext, clearUserContext } from '@/lib/sentry';
import { useAuth } from './useAuth';

/**
 * Hook to automatically track user context in Sentry
 * Call this in your main App component
 */
export const useErrorTracking = () => {
  const { user, orgId } = useAuth();

  useEffect(() => {
    if (user) {
      setUserContext({
        id: user.id,
        email: user.email,
        org_id: orgId || undefined,
      });
    } else {
      clearUserContext();
    }

    return () => {
      clearUserContext();
    };
  }, [user, orgId]);
};
